const TEST_DEFINITION_FIELDS = `
    id
    testCode
    name
    description
    applicationId
    steps {
      stepNumber
      actionCode
      inputs {
        key
        value
      }
      expect
    }
    status
    createdByUsername
    updatedByUsername
    created
    updated
`;

export const createTestDefinition = `
    mutation createTestDefinition($input: CreateTestDefinitionInput!) {
        createTestDefinition(input: $input) {
            ${TEST_DEFINITION_FIELDS}
    }
}`;

export const updateTestDefinition = `
    mutation updateTestDefinition($input: UpdateTestDefinitionInput!) {
        updateTestDefinition(input: $input) {
            ${TEST_DEFINITION_FIELDS}
    }
}`;

// deleteTestDefinition returns a bare `ID`, not an object — no sub-selection.
export const deleteTestDefinition = `
    mutation deleteTestDefinition($input: DeleteTestDefinitionInput!) {
        deleteTestDefinition(input: $input)
}`;

// setTestDefinitionStatus takes DIRECT ARGS, not an input object. Status changes
// go through this mutation and never through updateTestDefinition — it is a
// conditional write, so an illegal transition fails loud and the error is
// surfaced. Same seam as setActionStatus in testing-actions.
export const setTestDefinitionStatus = `
    mutation setTestDefinitionStatus($id: ID!, $targetStatus: TestDefinitionStatus!) {
        setTestDefinitionStatus(id: $id, targetStatus: $targetStatus) {
            ${TEST_DEFINITION_FIELDS}
    }
}`;
